module.exports = __webpack_public_path__ + "static/img/5-恒大地产.3e94b228.png";